var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTr = function SvgTr(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21778_20304",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#4171CF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21778_20304)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#D02F28"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33422 15.0988C5.51698 15.0988 3.23317 12.8154 3.23317 9.99863C3.23317 7.18187 5.51698 4.89844 8.33422 4.89844C10.3796 4.89844 12.1439 6.10212 12.957 7.83967C12.2394 6.70258 10.9718 5.94727 9.52774 5.94727C7.28984 5.94727 5.47567 7.76128 5.47567 9.99898C5.47567 12.2367 7.28984 14.0507 9.52774 14.0507C10.971 14.0507 12.238 13.2962 12.9558 12.1603C12.1421 13.8964 10.3786 15.0988 8.33422 15.0988Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7075 8.28859L14.5464 9.36211L15.8267 8.89633L15.0649 10.0256L15.9038 11.0991L14.5941 10.7235L13.8323 11.8528L13.7846 10.4914L12.4749 10.1158L13.7551 9.64998L13.7075 8.28859Z",
    fill: "#F6F8FA"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTr);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tr.d183012bcfb473ad8a200ef8609a297a.svg";